import PanelBox from '../../components/PanelBox';
import React from 'react'
import { connect } from "react-redux";

import { Form, Input, Tooltip, Icon, Cascader, Select, Row, Col, Checkbox, Button, Upload, notification } from 'antd';
const FormItem = Form.Item;


const mapStateToProps = (state) => {
  return {
    user: state.user
  }
}

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }


  render() {
    return (
      <PanelBox title="Главная">
        <Form>
          Content
        </Form>
      </PanelBox>
    );
  }
}

export default connect(mapStateToProps)(Home)



// WEBPACK FOOTER //
// ./src/views/Home/index.jsx